<template>
  <Modal
    :title="$t('edit_item_color')"
    modalId="edit-modal"
    @submit="updateItemColor"
  >
    <form @submit.prevent="updateItemColor">
      <div class="mb-3">
        <label class="form-label">{{ $t('item_color_name') }} <span class="">*</span></label>
        <input
          type="text"
          v-model="item.color"
          class="form-control"
        />
        <!-- Error for item size -->
        <div v-if="errors.color" class="text-danger mt-2">
          <span>{{ errors.color }}</span>
        </div>
      </div>
      <!-- General error message -->
      <div v-if="errorMessage" class="text-danger mt-2">{{ errorMessage }}</div>
    </form>
  </Modal>
</template>

<script>
import Modal from '@/components/common/Modal.vue';
import apiUrls from '../../../urls';
import {useToast} from "vue-toastification";

export default {
  components: {
    Modal,
  },

  props: {
    selectedItemColor: {
      type: Object,
      default: () => ({}),
    },
  },

  setup() {
    const toast = useToast()
    return {toast}
  },

  data() {
    return {
      item: {
        id: null,
        color: '',
      },
      errorMessage: '',  // General error message (if any)
      errors: {},        // For storing individual field errors
    };
  },
  watch: {
    selectedItemColor: {
      immediate: true,
      handler(newColor) {
        if (newColor && newColor.id) {
          this.item = { ...newColor };
        }
      },
    },
  },
  methods: {
    async updateItemColor() {
      try {
        const response = await this.$axios.patch(
          apiUrls.item_color.update.replace(':pk', this.item.id),
          { color: this.item.color }
        );

        this.toast.success('Color successfully updated!')

        // Close modal after success
        const modal = document.getElementById('edit-modal');
        const modalInstance = bootstrap.Modal.getInstance(modal);
        if (modalInstance) modalInstance.hide();

        // Emit event to update parent component
        this.$emit('edit_success');

        this.resetForm();
      } catch (error) {
        if (error.response) {
          if (error.response.data) {
            // Check if 'size' field is in errors and assign full error message
            if (error.response.data.color && error.response.data.color.length > 0) {
              // Assign the full error message from the array
              this.errors.color = error.response.data.color[0];
            }

            // Handle general error message from backend
            if (error.response.data.error) {
              this.errorMessage = error.response.data.error;
            }
          }
        }
      }
    },

    resetForm() {
      this.item = { id: null, size: '' };
      this.errors = {};
      this.errorMessage = '';
    },
  },
};
</script>